import { render, staticRenderFns } from "./AppointmentDetailsModal.vue?vue&type=template&id=3eb8f05f&scoped=true&"
import script from "./AppointmentDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./AppointmentDetailsModal.vue?vue&type=script&lang=ts&"
import style0 from "./AppointmentDetailsModal.vue?vue&type=style&index=0&id=3eb8f05f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb8f05f",
  null
  
)

export default component.exports